<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SkistarAccommodationImages',
  computed: {
    ...mapState({
      accommodation: state => state.skistar.accommodation.selected,
      show: state => state.skistar.accommodation.images.show,
      loading: state => state.skistar.accommodation.images.itemsLoading,
      images: state => state.skistar.accommodation.images.items,
    }),
    oldImages() {
      return Object.values(this.images)
        .filter(image => image.isNoLongerPartOfImport);
    },
    newImages() {
      return Object.values(this.images)
        .filter(image => !image.isNoLongerPartOfImport);
    },
  },
  methods: {
    ...mapActions({
      closeImages: 'skistar/closeAccommodationImages',
      activateImage: 'skistar/activateAccommodationImage',
      deactivateImage: 'skistar/deactivateAccommodationImage',
      deleteImage: 'skistar/deleteAccommodationImage',
    }),
  },
};
</script>

<template>
  <v-layout>
    <v-flex xs12 class="text-xs-right">
      <v-dialog
        v-model="show"
        @input="closeImages"
        width="1000"
      >
        <v-card tile>
          <v-layout row>
            <v-flex>
              <v-card-title class="modal-title">
                {{ accommodation.name }}, {{ accommodation.description}}
              </v-card-title>
            </v-flex>
            <v-flex>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  @click="closeImages"
                  color="red darken-1"
                  flat
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-progress-linear
              v-if="loading && Object.keys(images).length === 0"
              indeterminate
            />
            <template v-else>
              <v-container
                v-if="oldImages.length"
                grid-list-sm
                fluid
              >
              <h2>Old images</h2>
              <v-layout row wrap>
                  <v-flex
                    v-for="image in oldImages"
                    :key="image.identifier"
                    xs4
                  >
                    <v-card flat tile>
                      <v-img
                        :src="image.imageUrl"
                        height="160px"
                      >
                              <v-overlay
          absolute
        >
                        <v-layout>
                          <v-flex xs4>
                            <v-btn
                              :href="image.imageUrl"
                              color="white"
                              target="_blank"
                              icon
                              fab
                              small
                            ><v-icon>crop_original</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex
                            class="text-xs-right"
                            xs8
                          >
                            <v-btn
                              v-if="image.isImportedToTwenty"
                              @click="deleteImage(image.identifier)"
                              :disabled="loading"
                              color="red"
                              dark
                              small
                            >
                              Remove
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <v-chip
                              v-else
                              :ripple="false"
                              color="primary"
                              text-color="white"
                              label
                            >
                              Not imported
                            </v-chip>
                          </v-flex>
                        </v-layout>
                        </v-overlay>
                      </v-img>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container
                grid-list-sm
                fluid
              >
                <v-layout row wrap>
                  <v-flex
                    v-for="image in newImages"
                    :key="image.identifier"
                    xs4
                  >
                    <v-card flat tile>
                      <v-img
                        :src="image.imageUrl"
                        height="160px"
                      >
                        <v-layout>
                          <v-flex xs4>
                            <v-btn
                              :href="image.imageUrl"
                              color="white"
                              target="_blank"
                              icon
                              fab
                              small
                            ><v-icon>crop_original</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex
                            class="text-xs-right"
                            xs8
                          >
                            <v-btn
                              v-if="image.active"
                              @click="deactivateImage(image.identifier)"
                              :disabled="loading"
                              color="primary"
                              dark
                              small
                            >
                              Disable import
                              <v-icon>remove_circle</v-icon>
                            </v-btn>
                            <v-btn
                              v-else
                              @click="activateImage(image.identifier)"
                              :disabled="loading"
                              color="green"
                              dark
                              small
                            >
                              Enable import
                              <v-icon>add</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-img>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </template>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<style scoped lang="scss">
  @import '../../../assets/scss/variables';

  .modal-title {
    font-size: $font-size-md;
  }
</style>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarAccommodationImages.vue